/* jshint esversion: 6 */
import React from 'react';
import ImageEditorControls from 'app/components/PostingTool/Accessories/ImageEditorControls.jsx';
import MediaSourceMenu from 'app/components/PostingTool/MediaSourceMenu.jsx';
import MediaUploader from 'app/components/PostingTool/MediaUploader.js';

class ImageEditorModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hashes: [],
            imageData: [],
            alt_text: {},
            cover_ms: {},
            mb_id: 0,
            firstLoad: false,
            selectedImage: ''
        };

        this.updateMedia = this.updateMedia.bind(this);
        this.editMedia = this.editMedia.bind(this);
        this.removeMedia = this.removeMedia.bind(this);
    }

    static getDerivedStateFromProps(props, state) {

        if (!state.firstLoad) {
            let nextState = {
                firstLoad: true
            };

            if (props.accessoryServiceId) {
                nextState.mb_id = props.postData.services[props.accessoryServiceId].mb_id;
                if (props.postData.services[props.accessoryServiceId].alt_text !== undefined) {
                    nextState.alt_text = props.postData.services[props.accessoryServiceId].alt_text;
                }
                if (props.postData.services[props.accessoryServiceId].cover_ms !== undefined) {
                    nextState.cover_ms = props.postData.services[props.accessoryServiceId].cover_ms;
                }
            } else {
                nextState.mb_id = props.postData.shared.mb_id;
                if (props.postData.shared.alt_text !== undefined) {
                    nextState.alt_text = props.postData.shared.alt_text;
                }
                if (props.postData.shared.cover_ms !== undefined) {
                    nextState.cover_ms = props.postData.shared.cover_ms;
                }
            }

            if (props.mediaThumbs && props.mediaThumbs.length) {
                nextState.hashes = [];
                nextState.imageData = [];

                let hashes = [];
                if (props.accessoryServiceId) {
                    hashes = (props.postData.services[props.accessoryServiceId].hashes !== undefined) ? props.postData.services[props.accessoryServiceId].hashes : [];
                } else {
                    hashes = (props.postData.shared.hashes !== undefined) ? props.postData.shared.hashes : [];
                }

                // if hashes are present load by the hashes to preserve the order
                if (hashes.length) {
                    for (let i = 0; i < hashes.length; ++i) {
                        let media = props.mediaThumbs.find((media) => { return media.hash === hashes[i]});
                        if (media) {
                            nextState.hashes.push(media.hash);
                            nextState.imageData.push(media);
                        }
                    }
                } else {
                    for (let i = 0; i < props.mediaThumbs.length; ++i) {
                        nextState.hashes.push(props.mediaThumbs[i].hash);
                        nextState.imageData.push(props.mediaThumbs[i]);
                    }
                }

            }

            if (props.accessoryHash !== undefined && props.accessoryHash) {
                nextState.selectedImage = props.accessoryHash;
            }

            return nextState;

        }

        return null;

    }

    updateMedia(e) {
        e.preventDefault();

        this.props.confirmAction({
            accessoryServiceId: (this.props.accessoryServiceId !== undefined) ? this.props.accessoryServiceId : 0,
            mb_id: this.state.mb_id,
            hashes: this.state.hashes,
            alt_text: this.state.alt_text,
            cover_ms: this.state.cover_ms
        });

    }

    editMedia(e) {
         let hash = e.currentTarget.dataset.hash;
         
        this.props.showMediaEditor('fullEditor', this.props.accessoryServiceId, hash);

    }

    removeMedia(e) {
        let hash = e.currentTarget.dataset.hash,
            nextHashes = [...this.state.hashes],
            nextAlt = Object.assign({}, this.state.alt_text),
            nextCovers = Object.assign({}, this.state.cover_ms);

        const removeThumbCallback = (hash) => {
            nextHashes.splice(nextHashes.indexOf(hash), 1);

            // the user deleted all the images from the image editor view
            // close up shop
            if (nextHashes.length === 0) {
                this.props.cancelAction();
            }

            if (nextAlt[hash] !== undefined) {
                delete nextAlt[hash];
            }

            if (nextCovers[hash] !== undefined) {
                delete nextCovers[hash];
            }

            this.setState({
                hashes: nextHashes,
                alt_text: nextAlt,
                cover_ms: nextCovers
            });

        }

        e.preventDefault();
        e.stopPropagation();

        if (hash && this.state.mb_id !== undefined && this.state.mb_id > 0) {
            let formData = new FormData;
            formData.append('mb_id', this.state.mb_id);
            formData.append('action', 'remove');
            formData.append('hash', hash);
            formData.append('type', 'postMedia');

            MediaUploader({
                context: this,
                formData,
                onUploadProgress: (progress) => {},
                responseCallback: (response) => {
                    if (this.props.accessoryServiceId !== undefined && this.props.accessoryServiceId) {
                        this.props.removeThumb(hash, this.props.accessoryServiceId, () => {
                            removeThumbCallback(hash);
                        });
                    } else {
                        this.props.removeThumb(hash, null, () => {
                            removeThumbCallback(hash);
                        });
                    }
                },
                errorCallback: (error) => {
                    if (error.response) {
                        let errorData = error.response.data.errors || null,
                            errorMsgs = [];

                        const extractErrors = (obj) => {
                            if (Object.keys(obj).length) {
                                Object.keys(obj).map((key) => {
                                    if (typeof obj[key] === 'string') {
                                        errorMsgs.push(obj[key]);
                                    } else if (Object.keys(obj[key])) {
                                        extractErrors(obj[key]);
                                    }
                                });
                            }
                        };

                        // session died before upload
                        if (error.response.status === 403) {
                            window.location.reload();
                            return;
                        }

                        extractErrors(errorData);

                        if (errorMsgs.length) {
                            if (this.props.accessoryServiceId !== undefined) {
                                let mediaError = {};
                                mediaError[this.props.accessoryServiceId] = errorMsgs.join(" ");
                                this.props.updateMediaErrors(mediaError);
                            } else {
                                this.setState({
                                    errors: errorMsgs.join(" ")
                                });
                            }
                        }
                    }
                }
            });
        } else if (hash) {
            if (this.props.accessoryServiceId !== undefined && this.props.accessoryServiceId) {
                this.props.removeThumb(hash, this.props.accessoryServiceId, () => {
                    removeThumbCallback(hash);
                });
            } else {
                this.props.removeThumb(hash, null, () => {
                    removeThumbCallback(hash);
                });
            }
        }

    }

    render() {
        const hasMediaFieldSupport = (field) => {
            let hasSupport = false;

            if (this.props.selectedServices) {
                for (let i = 0; i < this.props.selectedServices.length; ++i) {
                    let svc = this.props.selectedServices[i];
                    if (this.props.posts.postValidators[svc] &&
                        this.props.posts.postValidators[svc].fields !== undefined &&
                         this.props.posts.postValidators[svc].fields[field] !== undefined) {
                        hasSupport = true;
                        break;
                    }
                }
            }

            return hasSupport;
        }

        const onThumbClick = (e) => {
            let hash = e.currentTarget.dataset.hash;
            // check if we need to open the video editor
            if (hash && hasMediaFieldSupport('cover_ms')) {
                let imageData = this.state.imageData.find((image) => { return image.hash === hash});

                if (imageData && imageData.type.match(/video/)) {
                    this.props.showMediaEditor('videoEditor', this.props.accessoryServiceId, hash);
                }
            }

            this.setState({
                selectedImage: hash
            });
        };

        const onDragEnd = (oldIndex, newIndex) => {
            let nextHashes = [...this.state.hashes],
                item = nextHashes.splice(oldIndex, 1);

            nextHashes.splice(newIndex, 0, item[0]);

            this.setState({
                hashes: nextHashes,
                selectedImage: item[0]
            });
        }

        const onAltTextChange = (e) => {
            let nextAltText = Object.assign({}, this.state.alt_text);
            nextAltText[this.state.selectedImage] = e.currentTarget.value;

            this.setState({
                alt_text: nextAltText
            });
        }

        let serviceId = (this.props.accessoryServiceId !== undefined && this.props.accessoryServiceId) ? this.props.accessoryServiceId : 0;
        let newImageButton = (
            <div className="media-button-wrapper">
                <MediaSourceMenu
                    {...this.props}
                    mediaSourceOptions={[{
                        key: 'upload',
                        icon: 'fa fa-upload',
                        label: 'Upload Files',
                        action: () => {
                            this.props.showMediaEditor('mediaUploader', serviceId, '', true);
                        }
                    },
                    {
                        key: 'unsplash',
                        icon: 'ds-icon icon-unsplash',
                        label: 'Unsplash',
                        action: () => {
                           this.props.showMediaEditor('galleryChooser', serviceId);
                        }
                    }]}/>
            </div>
        );

        return (
            <div className="pt-image-editor">
                <ImageEditorControls
                    {...this.props}
                    onThumbClick={onThumbClick}
                    editMedia={this.editMedia}
                    removeMedia={this.removeMedia}
                    onDragEnd={onDragEnd}
                    onAltTextChange={onAltTextChange}
                    selectedImage={this.state.selectedImage}
                    hashes={this.state.hashes}
                    imageData={this.state.imageData}
                    alt_text={this.state.alt_text}
                    hasMediaFieldSupport={hasMediaFieldSupport}/>
                <div className="pt-accessory-actions">
                    {newImageButton}
                    <button type="button" className="btn-delete action-delete" onClick={this.updateMedia}>
                        Save
                    </button>
                </div>
            </div>
        );
    }
}

ImageEditorModal.displayName = "ImageEditorModal";

export default ImageEditorModal;
